import React from 'react';
import { Button } from '../button/button';

export const FormConfirmation = ({ setShowConfirmation, resetForm, successMessage }) => {
  return (
    <div>
      {!!successMessage && successMessage}
      {!successMessage && (
        <>
          <h3>Vielen Dank für Ihre Anfrage</h3>
          <p>
            Wir werden uns bei Ihnen innerhalb von 24 stunden melden und freuen uns mehr über Ihr Projekt zu erfahren!
          </p>
        </>
      )}
      <br />
      <Button
        type="button"
        variant="primary"
        onClick={() => {
          setShowConfirmation(false);
          resetForm();
        }}
      >
        Formular einblenden
      </Button>
    </div>
  );
};
